const base = process.env.NODE_ENV === "development" ? '/' : '/'

export default {
  base
};



// WEBPACK FOOTER //
// ./src/env.js